// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"466":"e764061b","488":"0e1e2984","513":"5314d613","584":"20b7d131","585":"61d9139a","648":"0637d9e5"}[chunkId] + ".chunk.js";
};